<section data-qa='button-group-rating'>
  <div *ngFor='let statusItem of statusList'>
    <button mat-button mat-raised-button color='primary'
            [ngClass]="{'active': getActive(statusItem)}"
            [attr.data-qa]="'button-status$' + statusItem.id"
            (click)='onClickStatus(statusItem)'
            [disabled]='$any(loading$ | async)'>{{statusItem.displayName | localizedString | async}}</button>
  </div>
</section>
